import { Dexterity } from '@trackman/baseball-shared-components';

export const emptyGuid = '00000000-0000-0000-0000-000000000000';
export const undefinedValue = 'Undefined';
export const emptyPlayer = {
  id: emptyGuid,
  nameRef: '',
  position: '',
  isPlaceholder: false,
  foreignIds: [],
  battingHandedness: Dexterity.Undefined,
  height: null,
  strikeZoneBottom: null,
  strikeZoneTop: null,
  jerseyNumber: '',
};
